import { createHttpEndpoint } from '../../utils'

import type {
  GetListingsImportMetadata,
  PostListings,
} from './buyback-catalog.types'

/**
 * Get import specifications, list of expected columns and a csv template to
 * fill.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-buyback-api/definition#/paths/~1bm~1catalog~1buyback~1listings~1import~1metadata/get}
 */
export const getListingsImportMetadata =
  createHttpEndpoint<GetListingsImportMetadata>({
    method: 'GET',
    operationId: 'getRefurbisherCsvFields',
    path: '/bm/catalog/buyback/listings/import/metadata',
  })

/**
 * Import listings in bulk.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-buyback-api/definition#/paths/~1bm~1catalog~1buyback~1listings~1import/post}
 */
export const postListingsImport = createHttpEndpoint<PostListings>({
  method: 'POST',
  operationId: 'postRefurbisherCsvFile',
  path: '/bm/catalog/buyback/listings/import',
})

/**
 * Export listings in bulk.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-buyback-api/definition#/paths/~1bm~1catalog~1buyback~1listings~1export/post}
 */
export const postListingsExport = createHttpEndpoint<PostListings>({
  method: 'POST',
  operationId: 'postRequestRefurbisherCsvFile',
  path: '/bm/catalog/buyback/listings/export',
})
